import { resourceReducer } from 'redux-resource';

export default resourceReducer('quickUsage');

export const getCurrentUsage = (state, subId, format) => {
  const usage = state && state.resources && state.resources[subId];
  if (!format) {
    return usage;
  }

  let formattedUsage;
  if (usage && usage.data) {
    formattedUsage = {
      mb_used: parseFloat(usage.data.used),
      mb_avail: parseFloat(usage.data.remaining),
    }
    return formattedUsage;
  }

  return usage;
}
